/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CollectAndExportFilesRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {CollectAndExportFilesResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const collectAndExportFiles = (request:CollectAndExportFilesRequest, options?: CashRequestOptions) => post<CollectAndExportFilesRequest, CollectAndExportFilesResponse>("/2.0/cash/collect-and-export-files", request, {...options, rejectOnError: true })